import React, { Fragment, useEffect, useState } from "react";
import { userHasAnyRole } from "../../../utils/SecurityUtils";
import { FACHADMIN, SYSTEMADMIN, ZUST_SBA, ZUST_SBD } from "../../../consts/funktionaleRollen";
import "../../../styles/components/einleitstelleDaten.css";
import { useForm } from "../../../utils/FormUtils";

function VorbelastungDaten({ formFactory, vorbelastungen }) {
    const disabled = !userHasAnyRole([ZUST_SBD, ZUST_SBA, FACHADMIN, SYSTEMADMIN]);
    const [expandedVorbelastungIndex, setExpandedVorbelastungIndex] = useState(0);
    const { setValues } = useForm({ initialValues: vorbelastungen, readonly: true });

    useEffect(() => {
        if (Array.isArray(vorbelastungen)) {
            if (vorbelastungen.length < expandedVorbelastungIndex) {
                setExpandedVorbelastungIndex(0);
                setValues(vorbelastungen[0]);
            } else if (expandedVorbelastungIndex >= 0) {
                setValues(vorbelastungen[expandedVorbelastungIndex]);
            }
        }
    }, [vorbelastungen, expandedVorbelastungIndex, setValues]);

    function renderVorbelastungWerte() {
        return (
            <Fragment>
                {formFactory.renderNumberInput("vorbelastung.csb", "vorbelastung.csb", "CSB", disabled)}
                {formFactory.renderNumberInput("vorbelastung.pges", "vorbelastung.pges", "PGES", disabled)}
                {formFactory.renderNumberInput("vorbelastung.nges", "vorbelastung.nges", "NGES", disabled)}
                {formFactory.renderNumberInput("vorbelastung.nh4n", "vorbelastung.nh4n", "NH4N", disabled)}
                {formFactory.renderNumberInput("vorbelastung.bsb5", "vorbelastung.bsb5", "BSB5", disabled)}
                {formFactory.renderNumberInput("vorbelastung.aox", "vorbelastung.aox", "AOX", disabled)}
                {formFactory.renderNumberInput("vorbelastung.hg", "vorbelastung.hg", "HG", disabled)}
                {formFactory.renderNumberInput("vorbelastung.cd", "vorbelastung.cd", "CD", disabled)}
                {formFactory.renderNumberInput("vorbelastung.cr", "vorbelastung.cr", "CR", disabled)}
                {formFactory.renderNumberInput("vorbelastung.ni", "vorbelastung.ni", "NI", disabled)}
                {formFactory.renderNumberInput("vorbelastung.pb", "vorbelastung.pb", "PB", disabled)}
                {formFactory.renderNumberInput("vorbelastung.cu", "vorbelastung.cu", "CU", disabled)}
                {formFactory.renderNumberInput("vorbelastung.gei", "vorbelastung.gei", "GEI", disabled)}
            </Fragment>
        );
    }

    return (
        <div className="gridl tabsheet-content-margin"
             style={{gridTemplateColumns: "repeat(4, 1fr)", justifyContent: "center"}}>
            {renderVorbelastungWerte()}
        </div>
    );
}

export default VorbelastungDaten;
